export default __webpack_public_path__ + "static/media/profile-2.d53747d0.webp";